import { render, staticRenderFns } from "./questionLayout.vue?vue&type=template&id=2185fdcc&scoped=true"
import script from "./questionLayout.vue?vue&type=script&lang=js"
export * from "./questionLayout.vue?vue&type=script&lang=js"
import style0 from "./questionLayout.vue?vue&type=style&index=0&id=2185fdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2185fdcc",
  null
  
)

export default component.exports